import {
  Callout,
  DetailsList,
  DetailsListLayoutMode,
  FontWeights,
  IconButton,
  Link,
  SelectionMode,
  Text,
  mergeStyleSets,
} from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import React from 'react';
import { genkey } from '../../common/constants';
import { Sanciones, TablaGeneralPosiciones, TablaPosiciones } from '../../system/SystemClient';
import ClubImageCircle from '../Common/ClubImageCircle';

const TorneoTabTablaPosiciones = ({
  tablaPosiciones,
  tablaGeneralPosiciones,
  highlightClubId,
}: {
  tablaPosiciones: TablaPosiciones[];
  tablaGeneralPosiciones: TablaGeneralPosiciones[];
  highlightClubId?: string;
}) => {
  const getCols = (compact?: boolean) => {
    const columnsDesktop = [
      {
        key: 'posicion',
        name: '#',
        fieldName: 'posicion',
        minWidth: compact ? 10 : 70,
        maxWidth: compact ? 10 : 70,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.puesto}</span>;
        },
      },
      {
        key: 'club',
        name: 'Club',
        fieldName: 'club',
        minWidth: compact ? 90 : 400,
        maxWidth: compact ? 90 : 400,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return (
            <div>
              {compact ? (
                <>
                  <div style={{ display: 'inline-block' }}>
                    <ClubImageCircle escudo={item.club_escudo} width={19} height={19}></ClubImageCircle>
                  </div>

                  <span
                    style={{
                      fontSize: 12,
                      marginTop: 0,
                      display: 'inline-block',
                      position: 'relative',
                      bottom: 6,
                      left: 3,
                      fontWeight: !!highlightClubId && highlightClubId === item.clubId ? 500 : 400,
                      color: !!highlightClubId && highlightClubId === item.clubId ? 'red' : '#605e5c',
                    }}
                  >
                    {item.club}
                  </span>
                </>
              ) : (
                <>
                  <div style={{ display: 'inline-block' }}>
                    <ClubImageCircle escudo={item.club_escudo} width={30} height={30}></ClubImageCircle>
                  </div>

                  <span
                    style={{
                      fontSize: 16,
                      marginTop: 0,
                      display: 'inline-block',
                      position: 'relative',
                      bottom: 10,
                      left: 10,
                      fontWeight: !!highlightClubId && highlightClubId === item.clubId ? 500 : 400,
                      color: !!highlightClubId && highlightClubId === item.clubId ? 'red' : '#605e5c',
                    }}
                  >
                    {item.club}
                  </span>
                </>
              )}
            </div>
          );
        },
      },
      {
        key: 'PTS',
        name: 'PTS',
        fieldName: 'PTS',
        minWidth: compact ? 25 : 50,
        maxWidth: compact ? 25 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16, fontWeight: 500 }}>{item.puntos}</span>;
        },
      },

      {
        key: 'PJ',
        name: 'PJ',
        fieldName: 'PJ',
        minWidth: compact ? 20 : 50,
        maxWidth: compact ? 20 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return (
            <span className="text-center" style={{ fontSize: compact ? 12 : 16 }}>
              {item.partidosJugados}
            </span>
          );
        },
      },

      {
        key: 'pg',
        name: 'PG',
        fieldName: 'pg',
        minWidth: compact ? 20 : 50,
        maxWidth: compact ? 20 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return (
            <span className="text-center" style={{ fontSize: compact ? 12 : 16 }}>
              {item.partidosGanados}
            </span>
          );
        },
      },

      {
        key: 'PE',
        name: 'PE',
        fieldName: 'PE',
        minWidth: compact ? 20 : 50,
        maxWidth: compact ? 20 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.partidosEmpatados}</span>;
        },
      },

      {
        key: 'PP',
        name: 'PP',
        fieldName: 'PP',
        minWidth: compact ? 20 : 50,
        maxWidth: compact ? 20 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return (
            <span style={{ fontSize: compact ? 12 : 16 }}>
              {item.partidosPerdidos - item.partidosSinPresentacion}
            </span>
          );
        },
      },

      {
        key: 'CP',
        name: 'CP',
        fieldName: 'CP',
        minWidth: compact ? 20 : 50,
        maxWidth: compact ? 20 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.partidosSinPresentacion}</span>;
        },
      },

      {
        key: 'GF',
        name: 'GF',
        fieldName: 'GF',
        minWidth: compact ? 20 : 50,
        maxWidth: compact ? 20 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.golesAFavor}</span>;
        },
      },

      {
        key: 'GC',
        name: 'GC',
        fieldName: 'GC',
        minWidth: compact ? 20 : 50,
        maxWidth: compact ? 20 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.golesEnContra}</span>;
        },
      },
      {
        key: 'DF',
        name: 'DF',
        fieldName: 'DF',
        minWidth: compact ? 20 : 50,
        maxWidth: compact ? 20 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.golesAFavor - item.golesEnContra}</span>;
        },
      },

      {
        key: 'sanciones',
        name: '',
        fieldName: 'sanciones',
        minWidth: compact ? 20 : 70,
        maxWidth: compact ? 20 : 70,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return (
            <CalloutPuntosDescontados
              compact={!!compact}
              sanciones={item.sanciones}
            ></CalloutPuntosDescontados>
          );
        },
      },
    ];

    // if (compact) {
    //   const aux = columnsDesktop[6];
    //   columnsDesktop[6] = columnsDesktop[9];
    //   columnsDesktop[9] = aux;
    // }
    return columnsDesktop;
  };

  const getColsGeneral = (compact?: boolean) => {
    const columnsDesktop = [
      {
        key: 'posicion',
        name: '#',
        fieldName: 'posicion',
        minWidth: compact ? 10 : 70,
        maxWidth: compact ? 10 : 70,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.puesto}</span>;
        },
      },
      {
        key: 'club',
        name: 'Club',
        fieldName: 'club',
        minWidth: compact ? 90 : 400,
        maxWidth: compact ? 90 : 400,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return (
            <div>
              {compact ? (
                <>
                  <div style={{ display: 'inline-block' }}>
                    <ClubImageCircle escudo={item.club_escudo} width={19} height={19}></ClubImageCircle>
                  </div>

                  <span
                    style={{
                      fontSize: 12,
                      marginTop: 0,
                      display: 'inline-block',
                      position: 'relative',
                      bottom: 6,
                      left: 3,
                      fontWeight: !!highlightClubId && highlightClubId === item.clubId ? 500 : 400,
                      color: !!highlightClubId && highlightClubId === item.clubId ? 'red' : '#605e5c',
                    }}
                  >
                    {item.club}
                  </span>
                </>
              ) : (
                <>
                  <div style={{ display: 'inline-block' }}>
                    <ClubImageCircle escudo={item.club_escudo} width={30} height={30}></ClubImageCircle>
                  </div>

                  <span
                    style={{
                      fontSize: 16,
                      marginTop: 0,
                      display: 'inline-block',
                      position: 'relative',
                      bottom: 10,
                      left: 10,
                      fontWeight: !!highlightClubId && highlightClubId === item.clubId ? 500 : 400,
                      color: !!highlightClubId && highlightClubId === item.clubId ? 'red' : '#605e5c',
                    }}
                  >
                    {item.club}
                  </span>
                </>
              )}
            </div>
          );
        },
      },

      {
        key: 'PTS',
        name: 'PTS',
        fieldName: 'PTS',
        minWidth: compact ? 25 : 70,
        maxWidth: compact ? 25 : 70,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16, fontWeight: 700 }}>{item.puntos}</span>;
        },
      },
      {
        key: 'PJ',
        name: 'PJ',
        fieldName: 'PJ',
        minWidth: compact ? 20 : 70,
        maxWidth: compact ? 20 : 70,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return (
            <span className="text-center" style={{ fontSize: compact ? 12 : 16 }}>
              {item.partidosJugados}
            </span>
          );
        },
      },

      {
        key: 'Prom',
        name: 'Prom.',
        fieldName: 'Prom',
        minWidth: compact ? 25 : 70,
        maxWidth: compact ? 25 : 70,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return (
            <span style={{ fontSize: compact ? 12 : 16 }}>
              {' '}
              {parseFloat((item.puntos / item.partidosJugados).toFixed(3)).toString()}
            </span>
          );
        },
      },
      {
        key: 'Juniors',
        name: 'Juniors',
        fieldName: 'Juniors',
        minWidth: compact ? 25 : 50,
        maxWidth: compact ? 25 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.puntosJuniors}</span>;
        },
      },
      {
        key: 'Juveniles',
        name: 'Juveniles',
        fieldName: 'Juveniles',
        minWidth: compact ? 25 : 50,
        maxWidth: compact ? 25 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.puntosJuveniles}</span>;
        },
      },
      {
        key: 'Cadetes',
        name: 'Cadetes',
        fieldName: 'Cadetes',
        minWidth: compact ? 25 : 50,
        maxWidth: compact ? 25 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.puntosCadetes}</span>;
        },
      },
      {
        key: 'Menores',
        name: 'Menores',
        fieldName: 'Menores',
        minWidth: compact ? 25 : 50,
        maxWidth: compact ? 25 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.puntosMenores}</span>;
        },
      },
      {
        key: 'Infantiles',
        name: 'Infantiles',
        fieldName: 'Infantiles',
        minWidth: compact ? 25 : 50,
        maxWidth: compact ? 25 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.puntosInfantiles}</span>;
        },
      },

      {
        key: 'Mini',
        name: 'Mini',
        fieldName: 'Mini',
        minWidth: compact ? 25 : 50,
        maxWidth: compact ? 25 : 50,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.puntosMini}</span>;
        },
      },
      {
        key: 'sanciones',
        name: '',
        fieldName: 'sanciones',
        minWidth: compact ? 20 : 70,
        maxWidth: compact ? 20 : 70,
        isResizable: true,
        onRender: (item: TablaPosiciones) => {
          console.log('item', item);
          return (
            <CalloutPuntosDescontados
              compact={!!compact}
              sanciones={item.sanciones ?? []}
            ></CalloutPuntosDescontados>
          );
        },
      },
    ];

    return columnsDesktop;
  };

  return (
    <>
      {tablaPosiciones.length > 0 ? (
        <>
          {/* =====================================================================
                              VISTA DESKTOP
        =====================================================================*/}
          <div id="viewDesktop" className="ms-hiddenSm">
            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-sm12 text-center">
                <CalloutReferenciasTablas />

                <DetailsList
                  className="no-scroll"
                  onShouldVirtualize={() => false}
                  items={tablaPosiciones}
                  columns={getCols()}
                  setKey="set"
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                />
              </div>
            </div>
            {tablaGeneralPosiciones.map((item) => {
              return (
                <div className="ms-Grid-row mt-5">
                  <div className="ms-Grid-col ms-sm12 text-center">
                    <Text variant="mediumPlus" style={{ fontWeight: 500 }}>
                      {item.rotulo}
                    </Text>
                  </div>

                  <div className="ms-Grid-col ms-sm12 text-center">
                    <DetailsList
                      className="no-scroll"
                      onShouldVirtualize={() => false}
                      items={item.tabla}
                      columns={item.tipo == 'G' ? getColsGeneral() : getCols()}
                      setKey="set"
                      layoutMode={DetailsListLayoutMode.justified}
                      selectionMode={SelectionMode.none}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          {/* =====================================================================
                              VISTA MOBILE
        =====================================================================*/}

          <div id="viewMobile" className="ms-hiddenMdUp">
            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-sm12 text-center">
                <DetailsList
                  className=""
                  onShouldVirtualize={() => false}
                  items={tablaPosiciones}
                  columns={getCols(true)}
                  setKey="set"
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                />
              </div>
            </div>

            {tablaGeneralPosiciones.map((item) => {
              return (
                <div className="ms-Grid-row mt-5">
                  <div className="ms-Grid-col ms-sm12 text-center">
                    <Text variant="mediumPlus" style={{ fontWeight: 500 }}>
                      {item.rotulo}
                    </Text>
                  </div>

                  <div className="ms-Grid-col ms-sm12 text-center">
                    <DetailsList
                      className=""
                      onShouldVirtualize={() => false}
                      items={item.tabla}
                      columns={item.tipo == 'G' ? getColsGeneral(true) : getCols(true)}
                      setKey="set"
                      layoutMode={DetailsListLayoutMode.justified}
                      selectionMode={SelectionMode.none}
                      compact
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div className="ms-Grid-col ms-sm12 mt-2 text-center">
          <Text variant="medium">Todavía no hay tabla de posiciones para este torneo.</Text>
        </div>
      )}
    </>
  );
};

const CalloutPuntosDescontados = (props: { sanciones: Sanciones[]; compact: boolean }) => {
  const [isCalloutVisible, setIsCalloutVisible] = React.useState<boolean>(false);
  const toggleIsCalloutVisible = () => setIsCalloutVisible(!isCalloutVisible);
  const buttonId = useId(genkey());
  const labelId = useId(genkey());
  const descriptionId = useId(genkey());

  const styles = mergeStyleSets({
    callout: {
      width: 350,
      maxWidth: '90%',
      padding: '10px 14px',
    },
    title: {
      marginBottom: 12,
      fontWeight: FontWeights.semilight,
    },
    link: {
      display: 'block',
      marginTop: 20,
    },
  });

  return (
    <>
      {props.sanciones.length > 0 && (
        <>
          <IconButton
            iconProps={{ iconName: 'DecisionSolid' }}
            id={buttonId}
            onClick={toggleIsCalloutVisible}
            style={{ maxHeight: props.compact ? 22 : undefined }}
          />

          {isCalloutVisible && (
            <Callout
              className={styles.callout}
              ariaLabelledBy={labelId}
              ariaDescribedBy={descriptionId}
              role="dialog"
              gapSpace={0}
              target={`#${buttonId}`}
              onDismiss={toggleIsCalloutVisible}
              setInitialFocus
            >
              <Text variant="xLarge" className="fw-500" id={labelId}>
                Estas son las sanciones aplicadas:
              </Text>

              {props.sanciones.map((s) => {
                return (
                  <div className="mt-2">
                    <Text block className="d-block " variant="small" id={descriptionId}>
                      Expendiente (#{s.nroExpediente})
                    </Text>
                    <Text block className="d-block" variant="small" id={descriptionId}>
                      Puntos modificados: ({+s.puntosModificados * -1})
                      {s.categoria ? ` - ${s.categoria}` : ''} - {s.resolucionDescripcion}
                    </Text>
                  </div>
                );
              })}
            </Callout>
          )}
        </>
      )}
      <span
        className="error-color blinking-icon"
        style={{ fontSize: 16, fontWeight: 500 }}
        onClick={toggleIsCalloutVisible}
      >
        {props.sanciones && props.sanciones.length > 0 ? '(*)' : ''}
      </span>
    </>
  );
};

export const CalloutReferenciasTablas = () => {
  const [isCalloutVisible, setIsCalloutVisible] = React.useState<boolean>(false);
  const toggleIsCalloutVisible = () => setIsCalloutVisible(!isCalloutVisible);
  const buttonId = useId(genkey());
  const labelId = useId(genkey());
  const descriptionId = useId(genkey());

  const styles = mergeStyleSets({
    callout: {
      width: 200,
      maxWidth: '90%',
      padding: '10px 14px',
    },
    title: {
      marginBottom: 12,
      fontWeight: FontWeights.semilight,
    },
    link: {
      display: 'block',
      marginTop: 20,
    },
  });

  return (
    <div className="float-right mr-2">
      <Link id={buttonId} title="Ver referencias" onClick={toggleIsCalloutVisible}>
        Ver referencias
      </Link>

      {isCalloutVisible && (
        <Callout
          className={styles.callout}
          ariaLabelledBy={labelId}
          ariaDescribedBy={descriptionId}
          role="dialog"
          gapSpace={0}
          target={`#${buttonId}`}
          onDismiss={toggleIsCalloutVisible}
          setInitialFocus
        >
          <Text variant="medium" block style={{ fontWeight: 500 }} id={labelId}>
            PTS: <span style={{ fontWeight: 400 }}>Puntos totales</span>
          </Text>
          <Text variant="medium" block style={{ fontWeight: 500 }} id={labelId}>
            PJ: <span style={{ fontWeight: 400 }}>Partidos jugados</span>
          </Text>
          <Text variant="medium" block style={{ fontWeight: 500 }} id={labelId}>
            PG: <span style={{ fontWeight: 400 }}>Partidos ganados</span>
          </Text>
          <Text variant="medium" block style={{ fontWeight: 500 }} id={labelId}>
            PE: <span style={{ fontWeight: 400 }}>Partidos empatados</span>
          </Text>
          <Text variant="medium" block style={{ fontWeight: 500 }} id={labelId}>
            PP: <span style={{ fontWeight: 400 }}>Partidos perdidos</span>
          </Text>
          <Text variant="medium" block style={{ fontWeight: 500 }} id={labelId}>
            CP: <span style={{ fontWeight: 400 }}>Partidos cedidos</span>
          </Text>
          <Text variant="medium" block style={{ fontWeight: 500 }} id={labelId}>
            GF: <span style={{ fontWeight: 400 }}>Goles a favor</span>
          </Text>
          <Text variant="medium" block style={{ fontWeight: 500 }} id={labelId}>
            GC: <span style={{ fontWeight: 400 }}>Goles en contra</span>
          </Text>
          <Text variant="medium" block style={{ fontWeight: 500 }} id={labelId}>
            DF: <span style={{ fontWeight: 400 }}>Diferencia de goles</span>
          </Text>
        </Callout>
      )}
    </div>
  );
};

export default TorneoTabTablaPosiciones;
